import { Link, useNavigate } from "react-router-dom";
import BookCard, { Book } from "@/components/BookCard";
import { useBooks } from "@/hooks/useBooks";

const KnygynasStrip = () => {
  const { data: books, isLoading } = useBooks();
  const navigate = useNavigate();

  if (isLoading) return null;

  const handleBookSelect = (book: Book) => {
    navigate(book.slug ? `/knygynas/${book.slug}` : `/knygynas?book=${book.id}`);
  };

  return (
    <section className="bg-cream py-20 border-t border-ink/5">
      <div className="container mx-auto px-6">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-12 gap-6">
          <div>
            <span className="text-[11px] tracking-[0.22em] uppercase text-ink/55 font-semibold">— Knygynas —</span>
            <h2 className="font-marquee text-3xl md:text-5xl font-bold text-ink mt-3">Skaitymas augina</h2>
            <p className="text-ink/65 text-lg mt-2">
              Knygos vaikams ir suaugusioms.
            </p>
          </div>
          
          <Link 
            to="/knygynas" 
            className="hidden md:inline-flex text-ink/70 hover:text-terracotta text-sm tracking-wide font-medium transition-colors"
          >
            Knygynas →
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
          {books?.slice(0, 3).map((book) => (
            <BookCard key={book.id} book={book} onSelect={handleBookSelect} />
          ))}
        </div>

        <div className="text-center mt-10 md:hidden">
          <Link to="/knygynas" className="text-ink/70 hover:text-terracotta text-sm tracking-wide font-medium">
            Knygynas →
          </Link>
        </div>
      </div>
    </section>
  );
};

export default KnygynasStrip;
